module.exports = __webpack_public_path__ + "js-icon.svg?14bd8ad0ba588f3e649f26ecb97c56b5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/skill-icons/js-icon.svg
// module id = 44
// module chunks = 0